import { render, staticRenderFns } from "./SelectTicket.vue?vue&type=template&id=5ecfdcb6"
import script from "./SelectTicket.vue?vue&type=script&lang=js"
export * from "./SelectTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports